// extracted by mini-css-extract-plugin
export default {"search_container":"Recruitment_search_container__C+Vq1","recruit_post_section":"Recruitment_recruit_post_section__dY+RB","recruit_post_wrap":"Recruitment_recruit_post_wrap__u73Sp"};